import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router";
import "./index.css";
import App from "./App";
import { ConfigProvider } from "antd";
import UploadedFiles from "./components/UploadedFiles";
import { Provider } from "react-redux";
import store from "./store/store";
import { ProtectedRoute } from "./components/auth/ProtectedRoute";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <ConfigProvider theme={{ token: { colorPrimary: "#00b96b" } }}>
      {/* <React.StrictMode> */}
      <BrowserRouter basename="/vedas">
        <Routes>
          <Route path="/" element={<App />} />
         <Route
          path="/:id"
          element={
            <ProtectedRoute>
              <App />
            </ProtectedRoute>
          }
        />
          <Route path="/files" element={<UploadedFiles />} />
        </Routes>
      </BrowserRouter>
      {/* </React.StrictMode> */}
    </ConfigProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
